module.exports = __webpack_public_path__ + "img/icon-dropdown-arrow-down.b5e15128.svg";